<div class="h-full flex flex-col justify-start items-center overflow-hidden">
    @if (!agency()) {
    <p class="text-sm text-secondary px-2 py-4 m-0">Select an agency to edit profile.</p>
    } @else if (updatingAgencyInformation()) {
    <atom-loading-overlay></atom-loading-overlay>
    } @else {
    <form
        class="mx-auto h-full flex flex-col justify-start items-center overflow-y-auto w-full divide-y divide-zinc-200 dark:divide-zinc-800">
        <div class="space-y-12 w-full">
            <div
                class="mt-6 grid grid-cols-1 gap-x-8 gap-y-10 border-b border-zinc-500/10 dark:border-zinc-800 pb-12 md:grid-cols-3">
                <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-full w-full">
                    <div class="sm:col-span-3">
                        <label for="agency-name" class="block text-sm/6 font-medium text-primary">Agency name</label>
                        <div class="mt-2">
                            <input [formField]="agencyInformationForm.agencyName" id="agency-name" type="text"
                                autocomplete="organization" class="input-primary text-primary" />
                        </div>
                    </div>
                    <div class="sm:col-span-3">
                        <label for="agency-website" class="block text-sm/6 font-medium text-primary">Website</label>
                        <div class="mt-2 flex">
                            <div
                                class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 sm:text-sm/6">
                                https://</div>
                            <input [formField]="agencyInformationForm.agencyWebsite" id="agency-website" type="text"
                                placeholder="www.example.com" class="input-url text-primary" autocomplete="url" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <label for="agency-about" class="block text-sm/6 font-medium text-primary">About</label>
                        <div class="mt-2">
                            <textarea [formField]="agencyInformationForm.agencyAbout" id="agency-about" rows="3"
                                class="input-textarea text-primary"></textarea>
                        </div>
                        <p class="mt-1 text-xs leading-6 text-gray-600 m-0">Write a few sentences about this agency.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-6 flex items-center justify-end gap-x-6 w-full">
            <button type="button" (click)="saveChanges()" class="primary-button">Save</button>
        </div>
    </form>
    }
</div>
